import {CounterLabel} from '@primer/react'
import {Count, CountMode} from '@github-ui/count'
import Base from '../components/skeletons/Base'
import styles from './LazyCounter.module.css'

export default function LazyCounter({
  totalResults,
  isLoading,
  resultCountIsLowerBound,
}: {
  totalResults: number
  isLoading: boolean
  resultCountIsLowerBound?: boolean
}) {
  if (isLoading) {
    return <Base className={styles.skeleton} />
  }

  return (
    <CounterLabel data-testid="resolved-count-label" className={styles.counterLabel}>
      <Count mode={resultCountIsLowerBound ? CountMode.LowerBound : CountMode.Exact} value={totalResults} />
    </CounterLabel>
  )
}
